"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SendSMSTitle = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const common_1 = require("../../../../common");
const GlobalStateProvider_1 = require("../../../../GlobalStateProvider");
const DateRangeSelector_1 = __importDefault(require("../../DSTS004/DTST004_List_Child/DateRangeSelector"));
const SendStatusDropdown_1 = require("./SendStatusDropdown");
const SendSMSTitleStyled = styled_components_1.default.div `
	display: flex;
	flex-direction: column;
	width: 100%;
	gap: 10px;

	.active-bar {
		display: flex;
		flex-direction: row;
		gap: 16px;
		align-items: center;
		justify-content: flex-end;
		flex-shrink: 0;
		position: relative;

		.field-global-001 {
			flex-wrap: wrap;
			justify-content: flex-end;

			${props => props.$isMobile &&
    `
				> * {
					width: 100%;
				}
			`}
		}

		${props => props.$isTablet && `
			.dropdown-field {
				gap: 0px;
				padding: 10px 12px;
				height: 35px;
			}	
			
			.date-field {
				input {
					height: 35px;
					width: 110px !important;
				}
			}

			.search-bar-qna {
				padding: 8px 12px;
				height: 35px;
				gap: 2px;
				input {
					width: 130px;
				}
				input::placeholder {
					font-size: 12px;
				}	
			}
		`}
	}

	.divider {
		background: var(--color-grey-c, #e6e8ed);
		flex-shrink: 0;
		width: 1px;
		height: 42px;
		position: relative;
	}

	.search-bar {
		input {
			width: 159px;
		}
	}
`;
exports.SendSMSTitle = react_1.default.memo(({ sendStatus, startDate, endDate, setSendStatus, setStartDate, setEndDate, setKeyword, }) => {
    const { isDesktop, isTablet, isMobile } = (0, GlobalStateProvider_1.useGlobalState)();
    return (react_1.default.createElement(SendSMSTitleStyled, { className: "send-sms-title", "$isDesktop": isDesktop, "$isTablet": isTablet, "$isMobile": isMobile },
        react_1.default.createElement("div", { className: "active-bar" },
            react_1.default.createElement("div", { className: "field-global-001", style: {
                    flexDirection: isMobile ? 'column' : 'row',
                    width: isDesktop && 'unset',
                } },
                react_1.default.createElement(SendStatusDropdown_1.SendStatusDropdown, { sendStatus: sendStatus, setSendStatus: setSendStatus }),
                isDesktop && react_1.default.createElement("div", { className: "divider" }),
                react_1.default.createElement("div", { className: "date-field" },
                    react_1.default.createElement(DateRangeSelector_1.default, { defaultStartDate: startDate, defaultEndDate: endDate, setStartDate: setStartDate, setEndDate: setEndDate })),
                isDesktop && react_1.default.createElement("div", { className: "divider" }),
                react_1.default.createElement(common_1.SearchBar, { className: `${!isMobile ? `search-bar-qna ${isTablet && 'sm'}` : 'search-bar-mobile'}`, filterData: "name", handlerFilterList: (value) => {
                        // @ts-ignore
                        setKeyword(value.name);
                    } })))));
});
